<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="ch00_fm07"><a id="page_ix"></a><strong>CONTENTS</strong></h2>
<p class="noindent"><a class="nounder" href="#/xhtml/ch00_fm08_part1#ch00_fm08_part1">Nice N’Easy</a></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch09_part2#ch09_part2" title="Link target outside of Sample">Highlights (For Adults)</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch13_part3#ch13_part3" title="Link target outside of Sample">Platinum</span></p>
<p class="noindent"><span class="nounder" href="#/xhtml/ch23_part4#ch23_part4" title="Link target outside of Sample">Single Process</span><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm07.vue?459ee3c4